import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { CommonService } from './common.service';
import { AppConfigService } from './app-config.service';

@Injectable({
  providedIn: 'root'
})
export class GuestLoginService {

  constructor(private readonly oauthService: OAuthService, private readonly commonService: CommonService, private readonly appConfig: AppConfigService) {

  }
  enableGuestLogin() {
    if (this.oauthService.hasValidAccessToken()) {
      console.log('Access Token: ', this.oauthService.getAccessToken());
      this.commonService.ProjectLSData.LastSSOAppUrl = undefined;
      const isValidPath = !this.appConfig?.config?.ssoConfig?.invalidPaths?.some((path: any) => location.href.includes(path));
      if (isValidPath) {
        this.commonService.ProjectLSData.LastSSOAppUrl = location.href;
      }
      this.commonService.setProjectLSData();
      this.oauthService.initCodeFlow();
    } else {
      this.oauthService.initLoginFlow();
    }
  }
  logout() {
    this.oauthService.logOut();
  }
}
